import React from 'react';
import { observer } from 'mobx-react';
import { ListStore } from 'shared/stores/ListStore';
import { JobApplicationStore } from 'ats/pages/pipeline/components/JobApplicationStore';
import { PIPELINE_KPI_FILTERS } from 'ats/pages/pipeline/pipelineJobStats';
import { Pagination } from 'ats/components/pagination/Pagination';
import { eventManager } from 'ats/utils/EventManager';
import CandidatesTable from './components/CandidatesTable';

@observer
export class JobPositionCandidates extends React.Component {
	constructor(props) {
		super(props);
		this.jobApplicationStore = new JobApplicationStore();
		this.listStore = new ListStore(this.jobApplicationStore, {
			entityName: 'Job Application'
		});
	}

	getKpiFilterQuery = () => {
		if (!this.props.kpiFilter) {
			return {};
		}

		return PIPELINE_KPI_FILTERS[this.props.kpiFilter] || {};
	};

	preConfigureQuery() {
		this.listStore.store.resetQuery();
		this.listStore.store.query = {
			...this.listStore.store.query,
			jobId: this.props.jobPosition?.id,
			sort: {
				column: 'createdAt',
				asc: false
			},
			...this.getKpiFilterQuery()
		};
	}

	componentDidMount() {
		this.preConfigureQuery();
		if (this.props.jobPosition?.id) {
			this.listStore.search();
		}

		eventManager.on(
			'jobApplicationsListReload',
			this.handleJobApplicationsListReload
		);
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.jobPosition !== this.props.jobPosition ||
			prevProps.kpiFilter !== this.props.kpiFilter
		) {
			this.preConfigureQuery();
			if (this.props.jobPosition?.id) {
				this.listStore.search();
			}
		}
	}

	componentWillUnmount() {
		eventManager.off(
			'jobApplicationsListReload',
			this.handleJobApplicationsListReload
		);
	}

	handleJobApplicationsListReload = ({ jobId }) => {
		if (String(jobId) !== String(this.props.jobPosition?.id)) return;
		this.listStore.search();
	};

	handlePaginationChange = (page, limit) => {
		this.listStore.handlePaginationChange(page, limit);
	};

	render() {
		return (
			<div className="job-position-candidates">
				<div className="job-position-candidates-container">
					<CandidatesTable
						data={this.listStore.data}
						sort={this.listStore.store.query.sort}
						onSort={this.listStore.handleSort}
						job={this.props.jobPosition}
						onSuccess={() => {
							this.listStore.search();
							this.props.onSuccess?.();
						}}
					/>
				</div>
				<Pagination
					loading={this.listStore.loading}
					pagination={this.listStore.store.query.pagination}
					onPaginationChange={this.handlePaginationChange}
				/>
			</div>
		);
	}
}
